/* PepperPrints — Sezione prodotto.
   Cambio variante, galleria, quantità, barra sticky e campi obbligatori.
   L'invio al carrello resta di <product-form> di Dawn: qui non si tocca. */

(function () {
  'use strict';

  function parseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function PPProduct(root) {
    this.root = root;
    this.variants = parseJSON(root.querySelector('[data-pp-variants]')) || [];
    this.prices = parseJSON(root.querySelector('[data-pp-prices]')) || {};
    this.form = root.querySelector('form[data-type="add-to-cart-form"]');
    this.productForm = root.querySelector('product-form');
    this.idInput = root.querySelector('.product-variant-id');
    this.optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-option-input]'));
    this.submit = root.querySelector('[data-pp-submit]');
    this.submitText = root.querySelector('[data-pp-submit-text]');
    this.priceEl = root.querySelector('[data-pp-price-current]');
    this.wasEl = root.querySelector('[data-pp-price-was]');
    this.saveEl = root.querySelector('[data-pp-save]');
    this.viewer = root.querySelector('[data-pp-viewer]');
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-thumb]'));
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-pp-slide]'));
    this.bar = root.querySelector('[data-pp-bar]');
    this.barPrice = root.querySelector('[data-pp-bar-price]');
    this.barBtn = root.querySelector('[data-pp-bar-btn]');
    this.optionCount = 0;
    this.activeSlide = 0;

    // Al primo giro la galleria non si muove: a DOM appena costruito le immagini
    // non hanno ancora un layout stabile e uno scrollTo atterrerebbe fuori posto.
    this.allowMediaJump = false;

    this.optionInputs.forEach(
      function (input) {
        var i = parseInt(input.dataset.ppOptionInput, 10);
        if (i + 1 > this.optionCount) this.optionCount = i + 1;
      }.bind(this)
    );

    this.bindOptions();
    this.bindGallery();
    this.bindQuantity();
    this.bindCustomColors();
    this.bindUpsells();
    this.bindStickyBar();
    this.bindValidation();
    this.bindDescription();

    if (this.optionInputs.length) this.onOptionChange(false);

    var self = this;
    window.requestAnimationFrame(function () {
      self.allowMediaJump = true;
      self.alignToActive('auto');
    });
  }

  /* ---------- Varianti ---------- */

  PPProduct.prototype.selectedValues = function () {
    var values = [];
    for (var i = 0; i < this.optionCount; i++) {
      var checked = this.root.querySelector('[data-pp-option-input="' + i + '"]:checked');
      values.push(checked ? checked.value : null);
    }
    return values;
  };

  PPProduct.prototype.findVariant = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] !== null && v.options[j] !== values[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  };

  // Una combinazione va segnata come non disponibile prima del clic, non dopo.
  PPProduct.prototype.markAvailability = function (values) {
    this.optionInputs.forEach(
      function (input) {
        var index = parseInt(input.dataset.ppOptionInput, 10);
        var probe = values.slice();
        probe[index] = input.value;
        var found = null;
        for (var i = 0; i < this.variants.length; i++) {
          var v = this.variants[i];
          var ok = true;
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] !== null && v.options[j] !== probe[j]) {
              ok = false;
              break;
            }
          }
          if (ok && v.available) {
            found = v;
            break;
          }
        }
        input.dataset.unavailable = found ? 'false' : 'true';
      }.bind(this)
    );
  };

  PPProduct.prototype.onOptionChange = function (updateUrl) {
    var values = this.selectedValues();
    var variant = this.findVariant(values);

    this.markAvailability(values);

    // Etichetta accanto al nome dell'opzione
    for (var i = 0; i < this.optionCount; i++) {
      var label = this.root.querySelector('[data-pp-option-value="' + i + '"]');
      if (label && values[i]) label.textContent = values[i];
    }

    this.applyVariant(variant, updateUrl !== false);
  };

  PPProduct.prototype.applyVariant = function (variant, updateUrl) {
    var available = !!(variant && variant.available);

    if (this.idInput) {
      this.idInput.value = variant ? variant.id : '';
      this.idInput.disabled = !available;
    }

    var money = variant && this.prices[variant.id] ? this.prices[variant.id] : null;
    if (money) {
      if (this.priceEl) this.priceEl.textContent = money.price;
      if (this.barPrice) this.barPrice.textContent = money.price;
      if (this.wasEl) {
        this.wasEl.textContent = money.compare;
        this.wasEl.classList.toggle('hidden', !money.save);
      }
      if (this.saveEl) {
        this.saveEl.textContent = money.save;
        this.saveEl.classList.toggle('hidden', !money.save);
      }
    }

    if (this.submit) {
      this.submit.disabled = !available;
      if (this.submitText) {
        if (!variant) {
          this.submitText.textContent = 'Combinazione non disponibile';
        } else if (!variant.available) {
          this.submitText.textContent = 'Esaurito';
        } else {
          this.submitText.textContent = this.submit.dataset.ppLabel || 'Aggiungi al carrello';
        }
      }
    }
    if (this.barBtn) this.barBtn.disabled = !available;

    if (this.allowMediaJump && variant && variant.featured_media) this.goToMedia(variant.featured_media.id);

    if (updateUrl && variant && window.history && window.history.replaceState) {
      var url = this.root.dataset.url || window.location.pathname;
      window.history.replaceState({}, '', url + '?variant=' + variant.id);
    }
  };

  PPProduct.prototype.bindOptions = function () {
    if (!this.optionInputs.length) return;
    this.optionInputs.forEach(
      function (input) {
        input.addEventListener(
          'change',
          function () {
            this.onOptionChange(true);
          }.bind(this)
        );
      }.bind(this)
    );
  };

  /* ---------- Galleria ---------- */

  // Un solo punto in cui si calcola lo scorrimento: la larghezza del contenitore
  // moltiplicata per l'indice della slide, non offsetLeft. Le due grandezze
  // coincidono solo a layout finito, e al primo paint non lo è.
  PPProduct.prototype.alignToActive = function (behavior) {
    if (!this.viewer || !this.slides.length) return;
    var index = this.activeSlide;
    if (index < 0 || index >= this.slides.length) index = 0;
    this.viewer.scrollTo({ left: this.viewer.clientWidth * index, behavior: behavior || 'auto' });
  };

  PPProduct.prototype.goToMedia = function (mediaId) {
    if (!this.viewer) return;
    var target = this.root.querySelector('[data-media-id="' + mediaId + '"]');
    if (!target) return;
    var index = this.slides.indexOf(target);
    if (index < 0 || index === this.activeSlide) return;
    this.setActiveSlide(index);
    this.alignToActive('auto');
  };

  PPProduct.prototype.setActiveSlide = function (index) {
    if (index < 0) return;
    this.activeSlide = index;
    this.slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
    this.thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  };

  PPProduct.prototype.bindGallery = function () {
    if (!this.viewer) return;

    this.thumbs.forEach(
      function (thumb) {
        thumb.addEventListener(
          'click',
          function () {
            var index = parseInt(thumb.dataset.ppThumb, 10);
            if (!this.slides[index]) return;
            this.setActiveSlide(index);
            this.alignToActive('smooth');
          }.bind(this)
        );
      }.bind(this)
    );

    var ticking = false;
    this.viewer.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.setTimeout(
          function () {
            ticking = false;
            var width = this.viewer.clientWidth || 1;
            var index = Math.round(this.viewer.scrollLeft / width);
            if (index < 0) index = 0;
            if (index > this.slides.length - 1) index = this.slides.length - 1;
            if (index !== this.activeSlide) this.setActiveSlide(index);
          }.bind(this),
          120
        );
      }.bind(this),
      { passive: true }
    );

    // Il layout si assesta dopo il caricamento delle immagini e a ogni rotazione:
    // senza riallineamento la slide resta a metà fra due punti di aggancio.
    var realign = function () {
      this.alignToActive('auto');
    }.bind(this);

    window.addEventListener('load', realign);
    window.addEventListener('orientationchange', realign);
    window.addEventListener('resize', this.debounce(realign, 150));

    var first = this.slides[0];
    if (first) {
      var firstImg = first.querySelector('img');
      if (firstImg && !firstImg.complete) firstImg.addEventListener('load', realign, { once: true });
    }
  };

  PPProduct.prototype.debounce = function (fn, wait) {
    var timer;
    return function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, wait);
    };
  };

  /* ---------- Quantità ---------- */

  PPProduct.prototype.bindQuantity = function () {
    var input = this.root.querySelector('.pp-pdp__qty-input');
    if (!input) return;
    var buttons = Array.prototype.slice.call(this.root.querySelectorAll('[data-pp-qty]'));
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.ppQty, 10);
        var next = (parseInt(input.value, 10) || 1) + step;
        var min = parseInt(input.min, 10) || 1;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  /* ---------- Colori personalizzati ---------- */

  PPProduct.prototype.bindCustomColors = function () {
    var groups = Array.prototype.slice.call(this.root.querySelectorAll('.pp-pdp__custom-color'));

    groups.forEach(function (group) {
      var valueLabel = group.querySelector('.pp-pdp__option-value');
      var radios = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (valueLabel) valueLabel.textContent = radio.value;
          radio.removeAttribute('aria-invalid');
          var message = group.querySelector('[data-pp-field-error]');
          if (message) message.hidden = true;
        });
      });
    });
  };

  /* ---------- Extra e upsell ---------- */

  PPProduct.prototype.bindUpsells = function () {
    this.upsellRoot = this.root.querySelector('[data-pp-upsells]');
    if (!this.upsellRoot || !this.form) return;

    this.extraInputs = Array.prototype.slice.call(this.upsellRoot.querySelectorAll('[data-pp-extra]'));
    if (!this.extraInputs.length) return;

    this.upsellSummary = this.upsellRoot.querySelector('[data-pp-upsell-summary]');
    this.upsellTotal = this.upsellRoot.querySelector('[data-pp-upsell-total]');
    this.upsellError = this.upsellRoot.querySelector('[data-pp-upsell-error]');
    this.dynamicCheckout = this.form.querySelector('.shopify-payment-button');
    this.dynamicCheckoutWasHidden = this.dynamicCheckout ? this.dynamicCheckout.hidden : false;

    this.extraInputs.forEach(
      function (checkbox) {
        checkbox.addEventListener('change', this.paintUpsells.bind(this));
      }.bind(this)
    );

    this.form.addEventListener('submit', this.handleUpsellSubmit.bind(this), true);
    this.paintUpsells();
  };

  PPProduct.prototype.selectedExtras = function () {
    return (this.extraInputs || []).filter(function (checkbox) {
      return checkbox.checked && !checkbox.disabled;
    });
  };

  PPProduct.prototype.paintUpsells = function () {
    var selected = this.selectedExtras();
    var total = selected.reduce(function (sum, checkbox) {
      return sum + Number(checkbox.dataset.priceCents || 0);
    }, 0);

    if (this.upsellSummary && this.upsellTotal) {
      this.upsellSummary.hidden = total === 0;
      this.upsellTotal.textContent = this.formatUpsellMoney(total);
    }

    if (this.dynamicCheckout) {
      this.dynamicCheckout.hidden = selected.length > 0 ? true : this.dynamicCheckoutWasHidden;
    }
  };

  PPProduct.prototype.formatUpsellMoney = function (cents) {
    return new Intl.NumberFormat(this.upsellRoot.dataset.locale || 'it-IT', {
      style: 'currency',
      currency: this.upsellRoot.dataset.currency || 'EUR',
    }).format(cents / 100);
  };

  PPProduct.prototype.propertiesFromForm = function (formData) {
    var properties = {};
    formData.forEach(function (value, name) {
      var match = name.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') properties[match[1]] = value;
    });
    return properties;
  };

  PPProduct.prototype.handleUpsellSubmit = async function (event) {
    if (event.defaultPrevented) return;

    var extras = this.selectedExtras();
    if (!extras.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.hideUpsellError();

    var formData = new FormData(this.form);
    var variantId = Number(formData.get('id'));
    var quantity = Math.max(1, Number(formData.get('quantity') || 1));

    if (!variantId) {
      this.showUpsellError(this.upsellRoot.dataset.errorLabel);
      return;
    }

    var items = [
      {
        id: variantId,
        quantity: quantity,
        properties: this.propertiesFromForm(formData),
      },
    ];

    extras.forEach(
      function (checkbox) {
        items.push({
          id: Number(checkbox.dataset.variantId),
          quantity: checkbox.dataset.matchQuantity === 'true' ? quantity : 1,
          properties: {
            _Tipo: checkbox.dataset.kind,
            _Aggiunta: checkbox.dataset.lineLabel,
            _Per: this.upsellRoot.dataset.productTitle,
          },
        });
      }.bind(this)
    );

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    this.setUpsellBusy(true);

    try {
      var url =
        window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : window.Shopify.routes.root + 'cart/add.js';
      var response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      });
      var payload = await response.json();

      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || this.upsellRoot.dataset.errorLabel);
      }

      if (cart && payload.sections && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(payload);
      } else {
        window.location.assign(
          window.routes ? window.routes.cart_url : window.Shopify.routes.root + 'cart'
        );
      }
    } catch (error) {
      this.showUpsellError(error.message || this.upsellRoot.dataset.errorLabel);
    } finally {
      this.setUpsellBusy(false);
    }
  };

  PPProduct.prototype.setUpsellBusy = function (busy) {
    if (!this.submit) return;
    this.submit.toggleAttribute('aria-disabled', busy);
    this.submit.classList.toggle('loading', busy);
    var spinner = this.submit.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !busy);
  };

  PPProduct.prototype.showUpsellError = function (message) {
    if (!this.upsellError) return;
    this.upsellError.textContent = message || this.upsellRoot.dataset.errorLabel;
    this.upsellError.hidden = false;
    this.upsellError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  PPProduct.prototype.hideUpsellError = function () {
    if (!this.upsellError) return;
    this.upsellError.hidden = true;
    this.upsellError.textContent = '';
  };

  /* ---------- Barra sticky ---------- */

  PPProduct.prototype.bindStickyBar = function () {
    if (!this.bar || !this.submit || !('IntersectionObserver' in window)) return;
    this.bar.hidden = false;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        this.bar.classList.toggle('is-visible', !visible);
      }.bind(this),
      { rootMargin: '0px 0px -60px 0px' }
    );
    observer.observe(this.submit);
  };

  /* ---------- Campi obbligatori ---------- */

  PPProduct.prototype.bindValidation = function () {
    if (!this.form || !this.productForm) return;

    // Capture su <product-form>: gira prima del listener di Dawn sul form,
    // che altrimenti spedirebbe al carrello un ordine senza il nome inciso.
    this.productForm.addEventListener(
      'submit',
      function (event) {
        var invalid = this.firstInvalidField();
        if (!invalid) return;
        event.preventDefault();
        event.stopPropagation();
        invalid.setAttribute('aria-invalid', 'true');
        var wrapper = invalid.closest('.pp-pdp__field, .pp-pdp__option');
        var message = wrapper ? wrapper.querySelector('[data-pp-field-error]') : null;
        if (message) message.hidden = false;
        if (typeof invalid.focus === 'function') invalid.focus();
        invalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }.bind(this),
      true
    );

    var fields = Array.prototype.slice.call(this.form.querySelectorAll('[data-pp-required]'));
    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        field.removeAttribute('aria-invalid');
        var wrapper = field.closest('.pp-pdp__field');
        var message = wrapper ? wrapper.querySelector('[data-pp-field-error]') : null;
        if (message) message.hidden = true;
      });
    });
  };

  PPProduct.prototype.firstInvalidField = function () {
    var fields = Array.prototype.slice.call(this.form.querySelectorAll('[data-pp-required]'));
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].type === 'checkbox' && !fields[i].checked) return fields[i];
      if (!fields[i].value || !fields[i].value.trim()) return fields[i];
    }

    var groups = {};
    var radios = Array.prototype.slice.call(this.form.querySelectorAll('[data-pp-required-group]'));
    radios.forEach(function (radio) {
      var id = radio.dataset.ppRequiredGroup;
      if (!groups[id]) groups[id] = [];
      groups[id].push(radio);
    });
    for (var key in groups) {
      if (!Object.prototype.hasOwnProperty.call(groups, key)) continue;
      var checked = groups[key].some(function (radio) {
        return radio.checked;
      });
      if (!checked) return groups[key][0];
    }

    return null;
  };

  /* ---------- Descrizione espandibile ---------- */

  PPProduct.prototype.bindDescription = function () {
    var descriptions = Array.prototype.slice.call(this.root.querySelectorAll('[data-pp-description]'));

    descriptions.forEach(function (description) {
      var body = description.querySelector('[data-pp-description-body]');
      var toggle = description.querySelector('[data-pp-description-toggle]');
      if (!body || !toggle) return;

      var collapsedHeight = parseInt(description.dataset.collapsedHeight, 10) || 180;
      description.style.setProperty('--pp-description-height', collapsedHeight + 'px');

      // Il comando compare solo se il contenuto supera davvero l'altezza prevista.
      if (body.scrollHeight <= collapsedHeight + 8) return;

      description.classList.add('is-collapsed');
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', function () {
        var expanded = description.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        var label = toggle.querySelector('span');
        if (label) {
          label.textContent = expanded ? description.dataset.lessLabel : description.dataset.moreLabel;
        }
      });
    });
  };

  /* ---------- Avvio ---------- */

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('.pp-pdp');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.ppReady === 'true') continue;
      nodes[i].dataset.ppReady = 'true';
      new PPProduct(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
